// extracted by mini-css-extract-plugin
module.exports = {"perks":"perks-module--perks--3Nz1H","title":"perks-module--title--29p7r"};